export default __webpack_public_path__ + "static/media/upload.71f68b10.svg";